import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { errorCatch, GET, JSX, JSXMap, useAuth, useUserContext } from 'fennec-ui';
import { getIndexColor, getIndexColorAlt, isMyEvent } from '../../../../common/Tool';
import YImage from '../../../../common/YImage';

import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import { CapsuleTabs, SpinLoading } from 'antd-mobile';
var isBetween = require('dayjs/plugin/isBetween')
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isBetween)
dayjs.locale('ru');

export default function ByIDResult(props) {
    let { id } = useParams();
    const auth = useAuth();
    const user = useUserContext();
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState();

    useEffect(() => {
        setLoading(true);

        GET(auth, `/api/rezultati-final-dancer/${id}`,
            ({ data }) => {
                setResult(data)
                setLoading(false);
            }, (err)=>errorCatch(err, ()=>setLoading(false)));
    }, [])
    const admin = (result?.meropriyatie && user) ? isMyEvent(result?.meropriyatie, user, false) : false;

    return (
        <div style={{ height: "100%", overflowY: "scroll", backgroundColor: "white", padding: "0 15px", borderRadius: "4px" }}>
            {!!loading && <div style={{
                width: "100%",
                minHeight: "150px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            }}>
                <SpinLoading style={{ '--size': '32px' }} />
            </div>}
            {result?.meropriyatie && <div style={{ textAlign: "center", padding: "15px" }}>
                {/* <div style={{ fontSize: "16px", fontWeight: "100" }}>Ваши результаты для участия в мероприятии</div> */}
                <div style={{ fontSize: "22px", fontWeight: "600", lineHeight: "22px" }}>
                    <a href={`/fed/event/${id}`}>{result?.meropriyatie?.nazvanieMeropriyatiya}</a>
                </div>
                <div style={{ fontSize: "18px", fontWeight: "600", lineHeight: "30px" }}>г. {result?.meropriyatie?.mestoProvedeniya?.name}</div>
            </div>}
            {result?.meropriyatie && <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "15px", paddingBottom: "25px" }}>
                <div style={{ flex: "0 0 250px", maxWidth: "250px" }}>
                    <div style={{ width: "250px", height: "250px", overflow: "hidden", borderRadius: "6px" }}>
                        <YImage item={result?.meropriyatie} width={250} />
                    </div>
                    <div style={{ marginTop: "7px" }}>
                        <div style={{
                            backgroundColor: "#eaeaea",
                            fontSize: "16px",
                            fontWeight: "400",
                            color: "black",
                            borderRadius: "6px",
                            textAlign: "center",
                            padding: "0 7px",
                            textAlign: "center",
                        }}>
                            <div style={{
                                borderRadius: "5px",
                                backgroundColor: "#f6214b",
                                fontSize: "12px",
                                fontWeight: "600",
                                color: "white",
                                margin: "0 -7px",
                                boxShadow: "0px 6px 5px -5px rgb(34 60 80 / 60%",
                                padding: "3px 7px"
                            }}>
                                {dayjs(result?.meropriyatie?.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD.MM.YYYY')}
                            </div>
                            <div style={{
                                fontSize: "10px",
                                fontWeight: "400",
                                padding: "0px"
                            }}>
                                {dayjs(result?.meropriyatie?.nachaloSorevnovaniya).tz("Europe/Moscow").format('dddd')}
                            </div>
                        </div>
                    </div>
                </div>
                {result && <div style={{ width: "100%" }}>
                    <div>🕺💃🕺💃🕺💃🕺💃</div>
                    <div>✅ В сезоне {result?.meropriyatie?.sezonDlyaFinala} года Вы участвовали в соревнованиях Федерации – отборах на {result?.meropriyatie?.nazvanieMeropriyatiya}, 
                        который состоится {dayjs(result?.meropriyatie?.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD MMMM')} в г. {result?.meropriyatie?.mestoProvedeniya?.name}.</div>

                    {(result?.dancerMeropriyatiya?.length > 0) && <div style={{ marginTop: "15px" }}>
                        <div>💥 Вы участвовали в следующих соревнованиях Сезона {result?.meropriyatie?.sezonDlyaFinala}:</div>
                        {JSXMap(result?.dancerMeropriyatiya, (item, idx) => (
                            <div key={idx}>
                                <span>👉 {dayjs(item?.step.rezultatTantsoraVSerii.meropriyatieVSerii.meropriyatie.nachaloSorevnovaniya).tz("Europe/Moscow").format('DD.MM.YYYY')}, </span>
                                <span>{item?.step.rezultatTantsoraVSerii.meropriyatieVSerii.meropriyatie.mestoProvedeniya.name}, </span>
                                <span>{item?.step.rezultatTantsoraVSerii.meropriyatieVSerii.meropriyatie.nazvanieMeropriyatiya}, </span>
                                <span>категория </span>
                                <span>{item?.dancer.kategoriyaUchastnikovSerii.kategoriyaUchastnikov.nazvanie} - </span>
                                <span>{item?.dancer.kategoriyaUchastnikovSerii.tantsevalnayaDistsiplina.nazvanie}, </span>
                                <span>место {item?.step.rezultatTantsoraVSerii.place}.</span>
                            </div>
                        ))}
                    </div>}

                    {(result?.dancerSerii?.length > 0) && <div style={{ marginTop: "15px" }}>
                        <div>🕺💃🕺💃🕺💃🕺💃</div>
                        <div>✅ Соревнования, в которых Вы принимали участие, входили в следующие Серии:</div>
                        {JSXMap(result?.dancerSerii, (item, idx) => {
                            let kvota = 0;
                            if (item?.dancer?.kategoriyaUchastnikovSerii?.kvotiKategoriya?.length > 0) {
                                kvota = item.dancer.kategoriyaUchastnikovSerii.kvotiKategoriya[0].kvotaPartneri
                                if (item.dancer.uchastnik.genderID == 2) {
                                    kvota = item.dancer.kategoriyaUchastnikovSerii.kvotiKategoriya[0].kvotaPartnershi
                                }
                            }
                            return (<div key={idx}>
                                <span>👉 Серия: </span>
                                <span>{item.dancer.kategoriyaUchastnikovSerii.seriya.nazvanie} </span>
                                <span>(квота на {result?.meropriyatie?.nazvanieMeropriyatiya}: {kvota}), </span>
                                <span>Категория </span>
                                <span>{item.dancer.kategoriyaUchastnikovSerii.kategoriyaUchastnikov.nazvanie} - </span>
                                <span>{item.dancer.kategoriyaUchastnikovSerii.tantsevalnayaDistsiplina.nazvanie}, </span>
                                <span>Ваше итоговое место: </span>
                                <span>{item.dancer.place}.</span>
                            </div>
                            )
                        })}
                    </div>}

                    {(result?.rezultatiMeropriyatiyaDlyaFinala?.length > 0) && <div style={{ marginTop: "15px" }}>
                        <div>🕺💃🕺💃🕺💃🕺💃</div>
                        <div>✅ По результатам Сезона {result?.meropriyatie?.sezonDlyaFinala} Вы вошли в квоту на {result?.meropriyatie?.nazvanieMeropriyatiya} в следующих категориях:</div>
                        {JSXMap(result?.rezultatiMeropriyatiyaDlyaFinala, (item, idx) => (<div key={idx}>
                            <span>👉 Категория </span>
                            <span>{item.kategoriyaUchastnikovSerii.kategoriyaUchastnikov.nazvanie} - </span>
                            <span>{item.kategoriyaUchastnikovSerii.tantsevalnayaDistsiplina.nazvanie} </span>
                            <span>(из Серии {item.kategoriyaUchastnikovSerii.seriya.nazvanie}). </span>
                            <span>Баллы в зачет {result?.meropriyatie?.nazvanieDlyaFinalaRp}: </span>
                            <span>💥{item.pointsByTemplate}💥.</span>
                        </div>
                        ))}
                    </div>}
                    <div style={{ marginTop: "15px" }}>🕺💃🕺💃🕺💃🕺💃</div>
                    <div>От всей души поздравляем Вас!!</div>
                    <div>🕺💃🕺💃🕺💃🕺💃</div>

                    {(result?.marketDancer?.length > 0) && <div style={{ marginTop: "15px" }}>
                        {JSXMap(result?.marketDancer, (item, idx) => (<div key={idx}>
                            {(item.length > 1) && <div>
                                <span>✅ В категории </span>
                                <span>{item[0].kategoriyaUchastnikovSerii.kategoriyaUchastnikov.nazvanie} - </span>
                                <span>{item[0].kategoriyaUchastnikovSerii.tantsevalnayaDistsiplina.nazvanie} </span>
                                <span>Вы вошли в квоту по нескольким Сериям, в итоге Федерация дала Вам квоту из той Серии, из которой Вы придете на {result?.meropriyatie?.nazvanieMeropriyatiya} с бОльшим количеством очков. Ваше место в оставшихся Сериях Федерация отдала следующему по рейтингу этой Серии участнику.</span>
                            </div>}
                        </div>
                        ))}
                    </div>}

                    {(result?.isOutKvotaPlace) && <div style={{ marginTop: "15px" }}>
                        ✅ В некоторых Сериях Ваше итоговое место оказалось ниже, чем квота, но Вы все равно вошли в квоту. Это произошло из-за того, что некоторые участники, что были выше Вас, получили квоту от других Серий, и Вам Федерация предоставила их место в этой Серии.
                    </div>}

                    <div style={{ marginTop: "15px" }}>🕺💃🕺💃🕺💃🕺💃</div>
                    <div>Подтвердите, пожалуйста, свое участие в {result?.meropriyatie?.nazvanieDlyaFinalaPp}.</div>

                    {(result?.rezultatiMeropriyatiyaDlyaFinala?.length > 1) && <div style={{ marginTop: "15px" }}>
                        ✅ Вы получили квоту в нескольких категориях, но участвовать можно ТОЛЬКО В ОДНОЙ КАТЕГОРИИ, поэтому выберите категорию, в которой будете участвовать на {result?.meropriyatie?.nazvanieDlyaFinalaPp}. Мы рекомендуем выбрать более высокую категорию, так как чем выше категория, тем больше престиж.
                    </div>}

                    <div style={{ marginTop: "15px" }}>👉 Если не сможете принять участие, просьба все равно дать обратную связь.</div>
                    <div style={{ marginTop: "15px" }}>🕺💃🕺💃🕺💃🕺💃</div>
                    <div style={{ marginTop: "15px" }}>Регистрация на {result?.meropriyatie?.nazvanieMeropriyatiya} доступна по ссылке <a target="_blank" href={`https://social-dance.club/fed/event/${result?.meropriyatie?.ID}`}>https://social-dance.club/fed/event/{result?.meropriyatie?.ID}</a>.</div>
                    <div style={{ marginTop: "15px" }}>💥 На {result?.meropriyatie?.nazvanieDlyaFinalaPp} будет также награждение по общим зачетам всех Серий Сезона!!</div>
                    <div style={{ marginTop: "15px" }}>🕺💃🕺💃🕺💃🕺💃</div>
                    <div>Обратная связь в телеграме: Владимир Штотланд (89859241061).</div>
                    <div>Обратная связь в ВК – в чате с Федерацией, либо с <a target="_blank" rel="noopener noreferrer" href="https://vk.com/id2304069">Владимиром Штотландом</a></div>

                </div>}
            </div>}
        </div>
    );
}
